import networkAgent from "../services/network-agent.service";
import { Stats } from "../types/adminStats.types";

// ===========================================
// SIMPLIFIED API ENDPOINTS
// ===========================================

/**
 * Fetch video count statistics
 * Endpoint: GET /api/media/stats/video
 */
export const fetchVideoStats = async (): Promise<{ count: number }> => {
  const url = `${process.env.REACT_APP_API_URL}/api/media/stats/video`;
  const response = await networkAgent.getRequest<{ success: boolean; data: { count: number } }>(url);
  return response.data;
};

/**
 * Fetch audio count statistics
 * Endpoint: GET /api/media/stats/audio
 */
export const fetchAudioStats = async (): Promise<{ count: number }> => {
  const url = `${process.env.REACT_APP_API_URL}/api/media/stats/audio`;
  const response = await networkAgent.getRequest<{ success: boolean; data: { count: number } }>(url);
  return response.data;
};

/**
 * Fetch categories count statistics
 * Endpoint: GET /api/categories/stats
 */
export const fetchCategoryStats = async (): Promise<{ count: number }> => {
  const url = `${process.env.REACT_APP_API_URL}/api/categories/stats`;
  const response = await networkAgent.getRequest<{ success: boolean; data: { count: number } }>(url);
  return response.data;
};

/**
 * Fetch all simplified statistics in one call
 * Endpoint: GET /api/media/stats
 */
export const fetchAllStats = async (): Promise<Stats> => {
  const url = `${process.env.REACT_APP_API_URL}/api/media/stats`;
  const response = await networkAgent.getRequest<{ success: boolean; data: Stats }>(url);
  return response.data;
};
